<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      title="景区详情"
      width="80%"
      @close="close"
    >
    <el-row>
        <el-col :span="5">小程序链接：</el-col>
        <el-col :span="19">
          <span ref="path">
            ticket/detail/detail?spotId={{
              showForm.spotId
            }}
          </span>
          <el-button
            type="primary"
            class="ml-10"
            @click="copy"
            size="mini"
            plain
          >
            复制
          </el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">景区名称:</el-col>
        <el-col :span="19">{{ showForm.title }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">商品封面:</el-col>
        <el-col :span="19">
          <el-image
            :src="showForm.basic && showForm.basic.avatar"
            class="p-avatar"
          >
            <template v-slot:error class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </template>
          </el-image>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">商品轮播图:</el-col>
        <el-col :span="12">
          <el-carousel :interval="4000" height="160px" class="e-carousel">
            <el-carousel-item v-for="item in showForm.basic.imageList||[]" :key="item.name">
              <el-image :src="item.url" fit="scale-down"></el-image>
            </el-carousel-item>
          </el-carousel>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">经度:{{showForm.basic&&showForm.basic.lng}}</el-col>
        <el-col :span="12">维度:{{showForm.basic&&showForm.basic.lat}}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">景区介绍：</el-col>
        <el-col :span="15">
          <div
            class="rich-box"
            v-html="showForm.basic && showForm.basic.text"
          ></div>
        </el-col>
      </el-row>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { findSpot } from '@/api/ticket'
export default {
  name: 'SpotDetail',
  emits: ['fetch-data'],
  data() {
    return {
      showForm: {},
      dialogFormVisible: false,
    }
  },
  methods: {
    copy() {
      const text = this.$refs.path.innerText
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('复制成功')
    },
    async show(row) {
      const spotId = row.spotId
      const data = await findSpot({
        spotId,
      })
      this.showForm = data
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
</style>
